import type { FaireProductEntity } from "../../entity_types/product";

export const p_symvhyrgwc: FaireProductEntity = {
  token: "p_symvhyrgwc",
  type: "product",
  name: "Treatment Sucks Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/ef05ef2e85ec2266b0a8c45efbf3bcb305f7ad32f66255f743da43d174a08107.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2b4d150415dade8c0b72bcec94d39eff9d070a9b56c1bb8e7a1b7caf79fda8f9.png",
    "https://cdn.faire.com/fastly/80238f44183a86fc3c93c48a848c2bb44cfa97a575cf34ce7a2eaa63036155f7.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:44.797Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
